<template>
  <div class="ToastList">
    <ToastComponent
      v-for="(notificationItem, index) in notificationsArr"
      :key="`toastItem-${index}`"
      :notification="notificationItem"
      @close="$emit('close-toast', notificationItem)"
    />
  </div>
</template>
<script>
import ToastComponent from './ToastComponent.vue'

export default {
  name: 'ToastList',
  components: {
    ToastComponent
  },
  props: {
    notificationsArr: {
      type: Array,
      default: () => []
    }
  },
  emits: ['close-toast'],
  methods: {}
}
</script>
<style lang="scss">
.ToastList {
  width: 350px;
  height: auto;
  border-radius: var(--grid-8);
  align-items: flex-start;
  padding: var(--grid-8);
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  bottom: var(--grid-24);
  z-index: 1000;
  transition: all 0.6s ease;
}
</style>
